import React from "react";
import { useLang } from "@/i18n";
import { Globe } from "lucide-react";

export default function LanguageToggle({ className = "" }) {
    const { toggle, t } = useLang();
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="lang-toggle-btn"
            className={`inline-flex items-center gap-2 rounded-full border border-[var(--wd-accent)] bg-white/70 backdrop-blur px-4 py-2 text-xs tracking-widest text-[var(--wd-primary)] hover:bg-[var(--wd-accent-soft)] transition-all ${className}`}
            aria-label="Switch language"
        >
            <Globe size={14} />
            <span className="font-medium">{t("langSwitch")}</span>
        </button>
    );
}
